module.exports = __webpack_public_path__ + "static/app-shot-1-4-15ca43e96623c3eb0d9896a4ceec364c.jpg";